module.exports = __webpack_public_path__ + "img/bh_22.53553d07.jpg";